module.exports = __webpack_public_path__ + "static/media/mananagaram.e968081c.png";